import React from 'react';
import Typography from '@hpstellar/core/Typography';

import withPageComponents from '../../../page/components/with-page-components';
import BadgeContainer from '../../../main/components/badge-container';
import BadgeBanner from '../../../main/components/badge-banner';

export default withPageComponents(({ titleSection = {} }) => {
    const { title, badges = [] } = titleSection
    return (
        <div className={'title-section'}>
            <Typography
                tag="h1"
                variant="headingTitleLarge">
                {title}
            </Typography>
            <BadgeBanner
                className={'badge-header'}
                showFor={['desktop']}
            >
                {
                    badges.map(b => <BadgeContainer key={b.key} customMessage={b.text ? [b.text] : null} />)
                }
            </BadgeBanner>
        </div>);
}, { components: ['titleSection'] })